import { combineReducers } from "redux";

//Import all reducer
import common from "./common";
import home from "./home";
import brand from "./brand";
import category from "./category";
import ui from "./ui";
import user from "./user";
import blog from "./blog";
import payment from "./payment";
import booking from "./booking";
import sitemap from "./sitemap";
import mytrips from "./mytrips";
import userfavorite from "./userfavorite";
import vehicle from "./vehicle";

/******************* 
@purpose : Combine Reducer
@Parameter : {common,home,brand,category,ui,user,blog}
@Author : INIC
******************/
const rootReducer = combineReducers({
  common,
  home,
  brand,
  category,
  ui,
  user,
  blog,
  payment,
  booking,
  sitemap,
  mytrips,
  userfavorite,
  vehicle,
});

export default rootReducer;
